import MainLayoutPage from './mainLayoutPage';

export default MainLayoutPage;
